import { useAtomValue } from 'jotai'
import { localize } from '@/core/utils'
import { fgBuyNowButtonAtom } from './feelgreat.store'

/** Resolved label for any "Buy now" button, sourced from FG publish settings. */
export const useBuyNowText = (): string => {
    const buyNow = useAtomValue(fgBuyNowButtonAtom)
    return localize(buyNow?.buttonText)
}
